import UsersIndex from "@/components/user_access/UsersIndex.vue";
import UsersAdd from "@/components/user_access/UsersAdd.vue";
import UsersDetail from "@/components/user_access/UsersDetail.vue";
import UsersEdit from "@/components/user_access/UsersEdit.vue";
import UsersUpload from "@/components/user_access/UsersUpload.vue";

let routesUsersAccess= [
    {
        path: '',
        meta: {
          title: "List User Access",
        },
        name: "UsersIndex",
        component: UsersIndex
    },
    {
        path: 'create',
        meta: {
          title: "Create User Access",
        },
        name: "UsersAdd",
        component: UsersAdd
    },
     
    {
        path: 'detail/:id',
        meta: {
          title: "Detail User Access",
        },
        name: "UsersDetail",
        component: UsersDetail
    },
     
    {
        path: 'edit/:id',
        meta: {
          title: "Edit User Access",
        },
        name: "UsersEdit",
        component: UsersEdit
    },
    {
        path: 'upload',
        meta: {
          title: "Upload User Access",
        },
        name: "UsersUpload",
        component: UsersUpload
    },
    
]

export default routesUsersAccess
  